import { UserPlusIcon } from "@heroicons/react/24/outline";

import { Button } from "@fronterahealth/frontera-ui-components/ui/button";

import { ReviewRequestDialog } from "@components/ReportReview/ReviewRequestDialog";
import { useCanRequestReview } from "@components/ReportReview/hooks/useCanManageReview";

export const AddReviewerButton: React.FC = () => {
  const canRequestReview = useCanRequestReview();

  if (!canRequestReview) return null;

  return (
    <ReviewRequestDialog
      trigger={
        <Button variant="ghost" size="sm">
          <UserPlusIcon />
          Add reviewer
        </Button>
      }
    />
  );
};
